import React from 'react';
import Select from 'react-select';
import { TICKET_STATUSES } from '../../../../../constants/enums';
import { getTranslation } from '../../../../../utils/translation';

const Status = ({ selectedStatus, onBetHistoryStatusChange }) => {
    const options = [
        {
            value: TICKET_STATUSES.unknown,
            label: getTranslation('ticketStatusAll'),
        },
        {
            value: TICKET_STATUSES.won,
            label: getTranslation('ticketStatusWon'),
        },
        {
            value: TICKET_STATUSES.lost,
            label: getTranslation('ticketStatusLost'),
        },
        {
            value: TICKET_STATUSES.cancelled,
            label: getTranslation('ticketStatusCancelled'),
        },
        {
            value: TICKET_STATUSES.paid,
            label: getTranslation('ticketStatusPaid'),
        },
        {
            value: TICKET_STATUSES.refunded,
            label: getTranslation('ticketStatusRefunded'),
        },
        {
            value: TICKET_STATUSES.cashOut,
            label: getTranslation('ticketStatusCashOut'),
        },
    ];

    const selectedOption = options.find(option => option.value === selectedStatus);

    return (
        <Select
            className='common-select common-select--filters'
            classNamePrefix='common'
            menuPlacement={'auto'}
            isSearchable={false}
            value={selectedOption}
            onChange={onBetHistoryStatusChange}
            options={options}
        />
    );
};

export default Status;
